/**
 * Smart Sticky Columns for Shopify
 * Handles sticky elements that are taller than the viewport.
 */
class SmartSticky {
  constructor(el) {
    this.el = el;
    this.lastScrollY = window.scrollY;
    this.ticking = false;
    this.offset = 30; // Base offset from top/bottom
    
    // Get theme-specific sticky header height if available
    this.getHeaderHeight = () => {
      if (window.theme && typeof window.theme.stickyHeaderHeight === 'function') {
        return window.theme.stickyHeaderHeight();
      }
      const v = getComputedStyle(document.documentElement).getPropertyValue('--theme-sticky-header-height');
      return v ? parseInt(v, 10) || 0 : 0;
    };

    this.init();
  }

  init() {
    window.addEventListener('scroll', () => {
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          this.onScroll();
          this.ticking = false;
        });
        this.ticking = true;
      }
    }, { passive: true });
    
    // Initial call to set state
    this.onScroll();
  }

  onScroll() {
    const currentScrollY = window.scrollY;
    const viewportHeight = window.innerHeight;
    const elHeight = this.el.offsetHeight;
    const headerHeight = this.getHeaderHeight();
    const stickyTopLimit = this.offset + headerHeight;
    const stickyBottomLimit = viewportHeight - elHeight - this.offset;

    // Only apply smart logic if the element is taller than the viewport
    if (elHeight + stickyTopLimit > viewportHeight) {
      const scrollDiff = currentScrollY - this.lastScrollY;
      
      // Get current top, defaulting to the limit if not set or invalid
      const currentTop = parseFloat(getComputedStyle(this.el).top) || stickyTopLimit;
      
      // Calculate new top based on scroll difference
      let newTop = currentTop - scrollDiff;
      
      // Clamp the new top between the bottom and top limits
      newTop = Math.max(stickyBottomLimit, Math.min(stickyTopLimit, newTop));
      
      this.el.style.top = `${newTop}px`;
    } else {
      // Standard sticky for elements shorter than the viewport
      this.el.style.top = `${stickyTopLimit}px`;
    }

    this.lastScrollY = currentScrollY;
  }
}

// Initialize on all sticky-content-containers
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.sticky-content-container').forEach(el => {
    new SmartSticky(el);
  });
});
